import React from 'react';
import { BsFillCartFill } from 'react-icons/bs';
import { FaUser } from 'react-icons/fa';
import { GrLogout } from 'react-icons/gr';
import { RiFileListFill } from 'react-icons/ri';
import PropTypes from 'prop-types';
import palletflylogo from './images/palletflylogo.svg';

const Header = function header() {
  Header.propTypes = {
    cartVal: PropTypes.shape({ }).isRequired,
  };

  const handleDelete = () => {
    localStorage.removeItem('token');
    window.location.href = 'https://beta.palletfly.com/';
  };

  const handleCart = () => {
    window.location.href = 'https://beta.palletfly.com/cart';
  };
  const rightComponent = (
    <ul className="navbar-nav me-right mb-2 mb-lg-0">
      <li className="nav-item">
        <button type="button" onClick={() => handleCart()} className=" nav-link see-more-btn">
          <BsFillCartFill className="mb-1" size={15} />
          <span className="mx-1">My Cart</span>
        </button>

      </li>
      <li className="nav-item">
        <a className="nav-link " href="https://beta.palletfly.com/">
          <RiFileListFill className="mb-1" size={15} />
          <span className="mx-1">
            Request & Orders
          </span>
        </a>

      </li>
      <li className="nav-item">
        <a className="nav-link" href="https://beta.palletfly.com/account">
          <FaUser className="mb-1" size={15} />
          <span className="mx-1">My Account</span>
        </a>

      </li>
      <li className="nav-item">
        <button type="button" onClick={() => handleDelete()} className="nav-link logout-btn-style">
          <GrLogout className="mb-1" size={15} />
          <span className="mx-1">logout</span>
        </button>
      </li>
    </ul>
  );

  return (
    <div className="container-fluid">
      <nav className="navbar navbar-expand-lg navbar-light bg-white">
        <div className="logoView">
          <a className="navbar-brand" href="/" aria-label="nav"><img src={palletflylogo} alt="" /></a>
        </div>
        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon" />
        </button>
        <div className="container-fluid">
          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
              <li className="nav-item"><a className="nav-link" href="https://beta.palletfly.com/about">About</a></li>
              <li className="nav-item"><a className="nav-link" href="https://beta.palletfly.com/products">Products</a></li>
              <li className="nav-item"><a className="nav-link" href="https://beta.palletfly.com/brands">Brands</a></li>
              <li className="nav-item"><a className="nav-link" href="https://beta.palletfly.com/categories">Categories</a></li>
            </ul>
            {rightComponent}
          </div>
        </div>
      </nav>
    </div>
  );
};

export default Header;
